import { i18n } from "@/boot/i18n";
/**
 * Get the i18n translations to all the survey languages
 * to display the language equal the language of the survey
 * @param {the array of textual values} textualValues
 */

const labels = {
  extremely_hard: (language) => i18n.t("survey.textual.extremely_hard", language),
  very_hard: (language) => i18n.t("survey.textual.very_hard", language),
  hard: (language) => i18n.t("survey.textual.hard", language),
  neutral: (language) => i18n.t("survey.textual.neutral", language),
  easy: (language) => i18n.t("survey.textual.easy", language),
  very_easy: (language) => i18n.t("survey.textual.very_easy", language),
  extremely_easy: (language) => i18n.t("survey.textual.extremely_easy", language)
};

export default function getTextualLabels(textualValues, language = "pt_BR") {
  const newValues = JSON.parse(JSON.stringify(textualValues));
  newValues.map((likert) => {
    likert.label = labels[likert.label](language);
  });
  return newValues;
}
